import { Box } from '@leagueplatform/genesis-core';

import { AboutMeRoutes } from 'components/routes/lazy-routes.component';

// Hide the About Me tab bar in the UI without changing achievements_enabled, which also gates the rewards feature.
export function AboutMeRoutesWithoutTabs() {
  return (
    <Box css={{ '& [role="tablist"]': { display: 'none' } }}>
      <AboutMeRoutes />
    </Box>
  );
}
